import { createStyles } from '../../core/withStyles';
const styles = (theme) => createStyles({
    root: {
        color: theme.palette.text.primary,
        fontSize: theme.fontSizes.lg,
        fontWeight: 400,
        lineHeight: 1.5,
    },
});
export default styles;
//# sourceMappingURL=Heading2.styles.js.map